module.exports = "/wwwroot/img/measuring_station_map_block.png?ver=accd592b";